var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid",
      class: "container-fluid--" + _vm.mode,
      style: _vm.fluidStyle,
    },
    [
      !_vm.isPurchasable
        ? _c("div", { staticClass: "warning" }, [
            _c("div", { staticClass: "warning-inner" }, [
              _vm._v("판매 기간이 종료된 상품입니다."),
            ]),
          ])
        : _c("div", { staticClass: "container" }, [
            _c(
              "section",
              [
                _c("div", { staticClass: "bundle-cover" }, [
                  _c("div", { staticClass: "bundle-cover__img" }, [
                    _c("img", { attrs: { src: _vm.coverImgUrl, alt: "" } }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bundle-wrap bundle-cover__titles" },
                    [
                      _vm.subTitle
                        ? _c("h4", { style: { color: _vm.subTitleColor } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.subTitle) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h3", {
                        style: [{ color: _vm.titleColor }, _vm.titleStyle],
                        domProps: { innerHTML: _vm._s(_vm.title) },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("bundle-composition", {
                  attrs: {
                    productTotal: _vm.productTotal,
                    products: _vm.products,
                    goods: _vm.goods,
                    coverImgUrl: _vm.coverImgUrl,
                    pointColor: _vm.pointColor,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "bundle-wrap bundle-wrap-right" },
              [
                _vm.content
                  ? _c("div", {
                      staticClass: "bundle-content",
                      style: _vm.contentStyle,
                      domProps: { innerHTML: _vm._s(_vm.content) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "bundle-subimg" }, [
                  _vm.subImgUrl
                    ? _c("img", {
                        staticStyle: { width: "100%" },
                        attrs: { src: _vm.subImgUrl, alt: "" },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "bundle-prices",
                  _vm._b({}, "bundle-prices", _vm.prices, false)
                ),
                _vm._v(" "),
                _c("div", { staticClass: "bundle-btns" }, [
                  _c(
                    "button",
                    {
                      staticClass: "bundle-btn bundle-btn--full",
                      style: _vm.btnStyle,
                      on: { click: _vm.goPurchase },
                    },
                    [
                      _c("span", { staticClass: "btn-label" }, [
                        _vm._v(_vm._s(_vm.buttonLabel)),
                      ]),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }